import { FlowPickerState } from 'apps/flowPicker/store/types'

export const InitialState: FlowPickerState = {
  isOpen: false,
  source: null,
  selectedFlowId: null,
}
